<template>
	<div class="pushes-wrapper">
		<h2>
			<span class="header-icon"></span>
			<span class="text">Code Updates</span>
		</h2>
		<div v-for="p in pushList" v-bind:key="p.pushId" class="push">
			<div class="description">{{p.description}}</div>
			<div class="metrics">
				<i class="fas fa-code-branch fa-lg fa-fw"></i>
				{{p.targetBranch}}
			</div>
			<div class="details">{{p.relativeDateString}} - {{ p.dateString }}</div>
		</div>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let azurePushes = null;
	let githubPushes = null;

	export default {
		name: 'DevPushes',

		data() {
			return {
				azureList: [],
				githubList: [],
				pushList: [],
			};
		},

		mounted() {
			console.log("Development pushes module initiated");
			this.refreshAzurePushes();
			this.refreshGithubPushes();
			azurePushes = setInterval(this.refreshAzurePushes, 60000);
			githubPushes = setInterval(this.refreshGithubPushes, 60000);
		},
		
		destroyed() {
			console.log("Stopping Development pushes module");
			clearInterval(azurePushes);
			clearInterval(githubPushes);
		},
		
		methods: {

			refreshAzurePushes() {
				let self = this;
				self.$http.get('/code/azure-pushes', {}).then(response => {
					let data = response.body;
					self.azureList = data;
					self.compileList();
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});
			},

			refreshGithubPushes() {
				let self = this;
				self.$http.get('/code/github-pushes', {}).then(response => {
					let data = response.body;
					self.githubList = data;
					self.compileList();
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});

			},

			compileList() {
				let fullList = [];
				for (let x = 0; x < this.azureList.length; x++) fullList.push(this.azureList[x]);
				for (let x = 0; x < this.githubList.length; x++) fullList.push(this.githubList[x]);
				fullList.sort((a, b) => {
					return new Date(b.date) - new Date(a.date);
				});
				this.pushList = fullList.slice(0, Math.min(8, fullList.length));
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '../../less/_variables.less';
	@bg-pushes: #166559;
	@bg-pull-completed: #7FA750;
	@bg-pull-updated: #3683FF;
	@bg-pull-abandoned: #B24434;

	.pushes-wrapper {
		padding: 2%;
		width: 33%;
		height: 100%;
	}

	.push,
	.pull-completed,
	.pull-updated,
	.pull-abandoned {
		border-radius: @border-radius;
		margin-top: 0.3em;
		padding: 0.6em 1em;
		position: relative;
	}

	.build-icon {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		top: 0;
		width: 15%;
		height: 100%;
		background-size: 70%;
		background-position: center center;
		background-repeat: no-repeat;
	}

	.github {
		background-image: url(images/github.svg);
	}

	.azure {
		background-image: url(images/visual-studio.svg);
	}

	.push {
		background-color: @bg-pushes;
	}

	.pull-completed {
		background-color: @bg-pull-completed;
	}

	.pull-updated {
		background-color: @bg-pull-updated;
	}

	.pull-abandoned {
		background-color: @bg-pull-abandoned;
	}

	.description {
		font-weight: 700;
		font-size: 1.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.metrics {
		line-height: 1.4em;
		padding-top: 0.2em;
	}

	.metric-item {
		display: inline-block;
		padding-left: 0.3em;
	}

	.details {
		line-height: 1.4em;
		padding-top: 0.2em;
		opacity: 0.6;
	}

	h2 {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 0;
		font-size: 2em;
		line-height: 1em;

		span.header-icon {
			background-size: contain;
			background-position: center center;
			background-repeat: no-repeat;
			width: 1.7em;
			height: 1.7em;
			background-image: url(images/commits.svg);
		}

		span.text {
			text-transform: uppercase;
			padding-left: 0.5em;
		}
	}
</style>


// WEBPACK FOOTER //
// dev-pushes.vue?a58e98ee